/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
import { Column, Row } from "components/styles";
import { Fields } from "./styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import CustomSelect from "components/CustomSelect/CustomSelect";
import CustomTextArea from "components/CustomTextArea/CustomTextArea";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
//#endregion
//#region Utils
import { RESOURCES_CONSTANTS } from "config/constants";
import useChangePenaltiesByReasonForPenalize from "views/Recursos/ResourcesLibrary/SchedulesWrapper/ReservationData/utils/hooks/useChangePenaltiesByReasonForPenalize";
import { getOptionsToCustomSelect } from "components/CustomSelect/utils";
import { handlerKeyPressOnlyNumbers } from "utils/validations";
import { 
    STYLE_PROPS_CUSTOM_SELECT,
    INIT_FORM,
    DETAILS_PLACEHOLDERS } from "./utils/constants";
import usePrevious from "utils/hooks/usePrevious";
import useChangeBlockListByPenalize from "views/Recursos/ResourcesLibrary/SchedulesWrapper/ReservationData/utils/hooks/useChangeBlockListByPenalize";
//#endregion

const { REASON_FOR_PENALIZE_IDS, BLOCK_IDS } = RESOURCES_CONSTANTS;

const Content = ({
    form, isForDaysPenalize,
    fillIsForDaysForm,
    changeField,
    data: {
        reasonsForPenalize,
        penalties,
        blockList
    }, subtitle,
    isUpdate
}) => {
    const prevBlockId = usePrevious(form.blockId);
    //#region Functions
    const changeDetails = value => {
        changeField("details", value);
    }
    const changeReasonForPenalizeId = value => {
        changeField("reasonForPenalizeId", value);
        fillIsForDaysForm(value);
    }
    const changePenalizeId = value => {
        changeField("penalizeId", value);
    }
    const changeBlockId = value => {
        changeField("blockId", value);
        if (prevBlockId !== 0 && prevBlockId !== value) 
            changeDetails("");
    }
    const changePenalizeDays = value => {
        changeField("penalizeDays", value);
    }
    //#endregion
    //#region Extras
    const { penaltyTypeListFiltered } = useChangePenaltiesByReasonForPenalize({
        penaltyTypeList: penalties,
        reasonForPenalizeId: form.reasonForPenalizeId,
        changePenalizeId
    });
    const { blockListFiltered } = useChangeBlockListByPenalize({
        blockList,
        penaltyTypeId: form.penalizeId,
        changeBlockId,
        isUpdate
    });
    //#endregion
    const showPenaltyField = !isForDaysPenalize && penaltyTypeListFiltered.length > 0 && form.blockId !== BLOCK_IDS.UNBLOCK;
    const showBlockField = !isForDaysPenalize && blockListFiltered.length > 0;
    return (
        <Column>
            <p className="paragraph center">{subtitle}</p>
            <Fields className="custom-scrollbar primary">
                <Row justifyContent="flex-start">
                    <CustomSelect
                        label="Motivo"
                        value={form.reasonForPenalizeId}
                        onChange={changeReasonForPenalizeId}
                        defaultOptionText="Elige un Motivo"
                        {...STYLE_PROPS_CUSTOM_SELECT}
                        optionsProps={getOptionsToCustomSelect(reasonsForPenalize, { id: "id", text: "name" })}
                        disabled={isUpdate}/>
                    {showPenaltyField &&
                    <CustomSelect
                        label="Sanción"
                        value={form.penalizeId}
                        onChange={changePenalizeId}
                        defaultOptionText="Elige un Sanción"
                        {...STYLE_PROPS_CUSTOM_SELECT}
                        optionsProps={getOptionsToCustomSelect(penaltyTypeListFiltered, { id: "id", text: "name" })}
                        disabled={penaltyTypeListFiltered.length === 1}/>}
                    {showBlockField &&
                    <CustomSelect
                        label="Bloqueo"
                        value={form.blockId}
                        onChange={changeBlockId}
                        defaultOptionText="Elige un Bloqueo"
                        {...STYLE_PROPS_CUSTOM_SELECT}
                        optionsProps={getOptionsToCustomSelect(blockListFiltered, { id: "id", text: "name" })}
                        disabled={!isUpdate && form.reasonForPenalizeId === REASON_FOR_PENALIZE_IDS.NO_REFUND}/>}
                    {isForDaysPenalize && 
                    <CustomTextInput
                        label="Días de sanción"
                        placeholder="Días"
                        value={form.penalizeDays}
                        minWidth="170px"
                        width="170px"
                        maxLength={3}
                        onKeyPress={handlerKeyPressOnlyNumbers}
                        onChange={changePenalizeDays}/>}
                </Row>
                <CustomTextArea
                    label="Detalles"
                    placeholder={DETAILS_PLACEHOLDERS[form.blockId] || DETAILS_PLACEHOLDERS[BLOCK_IDS.TEMPORARY_BLOCK]}
                    value={form.details}
                    onChange={changeDetails}
                    showCharCounter={false}
                    maxLength={400}
                    height="50px"/>
            </Fields>
        </Column>
    );
}

const PenalizeDialog = ({
    dialogShow, 
    form, setForm,
    penalty, applyPenalty,
    close
}) => {
    const isUpdate = Boolean(penalty.value);
    //#region States
    const [isForDaysPenalize, setIsForDaysForm] = useState(false);
    //#endregion
    //#region Effects
    useEffect(() => {
        if (!dialogShow.value) return;
        if (!penalty.value) {
            setForm({ ...INIT_FORM });
            return;
        }
        fillIsForDaysForm(penalty.value.reasonForPenalizeId);
        setForm({ ...penalty.value });
    }, [dialogShow.value]);
    useEffect(() => {
        if (!dialogShow.value || 
            isUpdate ||
            form.reasonForPenalizeId !== REASON_FOR_PENALIZE_IDS.NO_REFUND) return;
        changeField("blockId", BLOCK_IDS.TEMPORARY_BLOCK); 
    }, [dialogShow.value, form.reasonForPenalizeId]);
    //#endregion
    //#region Functions
    const fillIsForDaysForm = reasonForPenalizeId => {
        setIsForDaysForm(penalty.data.reasonsForPenalize.find(({ id }) => id === reasonForPenalizeId)?.isForDays || false);
    }
    const changeField = (field, value) => {
        setForm(prev => ({
            ...prev,
            [field]: value
        }));
    }
    const isCompletedForm = () => {
        const { details, reasonForPenalizeId } = form;
        let completed = Boolean(
            (!details || details.length <= 400) &&
            reasonForPenalizeId
        );
        if (reasonForPenalizeId !== RESOURCES_CONSTANTS.REASON_FOR_PENALIZE_IDS.NO_REFUND) {
            const { penalizeDays } = form;
            completed = Boolean(
                completed && 
                parseInt(penalizeDays) > 0
            );
        }
        else {
            const { penalizeId, blockId } = form;
            completed = Boolean(
                completed && 
                penalizeId && 
                blockId
            );
        }
        return completed;
    }
    const areThereChangesWhenIsUpdate = () => {
        if (!isUpdate) return true;
        const { details, reasonForPenalizeId } = form;
        const { value: penaltyPreloaded } = penalty;
        let areThereChanges = (
            details !== penaltyPreloaded.details
        );
        if (reasonForPenalizeId !== RESOURCES_CONSTANTS.REASON_FOR_PENALIZE_IDS.NO_REFUND) {
            const { penalizeDays } = form;
            areThereChanges = (
                areThereChanges || 
                penalizeDays !== penaltyPreloaded.penalizeDays
            );
        }
        else {
            const { blockId, penalizeId } = form;
            areThereChanges = (
                areThereChanges || 
                penalizeId !== penaltyPreloaded.penalizeId || 
                blockId !== penaltyPreloaded.blockId
            );
        }
        return areThereChanges;
    }
    //#endregion
    const dialogProps = isUpdate
        ? {
            wrapper: {
                title: "¿Deseas editar la sanción del alumno?",
            },
            content: {
                subtitle: "Recuerda que al editar la sanción, la sanción se actualizará automáticamente."
            },
            proceedButton: {
                text: "Sí, editar"
            }
        } : {
            wrapper: {
                title: "¿Deseas sancionar al alumno?"
            },
            content: {
                subtitle: "Recuerda que para sancionar a un alumno, debes completar los siguientes campos."
            },
            proceedButton: {
                text: "Sí, sancionar"
            }
        };
    return (
        <DialogAlertAction 
            show={dialogShow.value}
            toggleShow={dialogShow.toggle}
            close={close}
            variant="secondary"
            {...dialogProps.wrapper}
            contentComponent={
                <Content 
                    {...dialogProps.content}
                    form={form} 
                    changeField={changeField} 
                    isForDaysPenalize={isForDaysPenalize} 
                    fillIsForDaysForm={fillIsForDaysForm} 
                    data={penalty.data}
                    isUpdate={isUpdate}/>}
            widthContent="100%"
            minWidth="650px"
            spacingContainer="10px">
            <CustomButton 
                {...dialogProps.proceedButton}
                width="130px"
                onClick={() => applyPenalty(isUpdate)}
                disabled={!isCompletedForm() || !areThereChangesWhenIsUpdate()}/>
            <CustomButton 
                text="No, cancelar"
                width="130px"
                variant="secondary"
                onClick={() => close ? close() : dialogShow.set(false)}/>
        </DialogAlertAction>
    );
}

export default PenalizeDialog;